<template>
  <div class="container lnb d_container">
    <div class="contents_wrap">
      <div class="contents list-container">
        <div class="title">
          {{ this.termsSetType(termsType) }}
        </div>
          <terms-write-component :termsType="'termsUpdate'" :termsCategory="termsCategory" :termsKey="termsKey"></terms-write-component>
        <div class="pa15 text-center btn_wrap">
          <el-button class="reg_btn_out" @click="save">저장</el-button>
<!--          <el-button class="reg_btn_out" @click="deleteTerms">삭제</el-button>-->
          <el-button class="com_btn" @click="backEvent">목록</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EventBus from "@/utils/event-bus";
import TermsWriteComponent from "@/components/terms/TermsWriteComponent";

export default {
  name: "TermsDetail",
  mixins: [],
  components: {TermsWriteComponent},
  provide() {
    return {
      'setTermsData': this.setTermsData,
    }
  },
  props: {},
  data() {
    return {
      termsCategory: this.$route.params.type,
      termsKey: this.$route.params.idx,
      termsData: [],
    }
  },
  created() {
    // this.termsKey = this.$route.params.c_idx;
  },
  mounted() {
  },
  beforeDestroy() {
  },
  destroyed() {
  },
  computed: {},
  methods: {
    deleteTerms() {
      EventBus.$emit('openDeleteConfirm')
    },
    setTermsData(value) {
      this.termsData = value;
    },
    save() {
      // this.$router.push(`/site/terms/${this.termsType}/${this.termsKey}/update`);
      EventBus.$emit('updateTerms');
    },
    backEvent() {
      this.$router.back()
    },
    termsSetType(termsKey) {
      if (termsKey === 'service') {
        return '서비스 이용약관'
      } else if (termsKey === 'privacy') {
        return '개인정보처리방침'
      } else if (termsKey === 'leave') {
        return '회원탈퇴약관'
      } else if(termsKey === 'auctionSell') {
        return '경매 판매 규정'
      } else if(termsKey === 'product') {
        return '아이템 등록 규정'
      } else if(termsKey === 'auctionBuy') {
        return '입찰 및 낙찰 규정'
      } else if(termsKey === 'licenseSell') {
        return '라이센스 판매 규정'
      } else if(termsKey === 'licenseBuy') {
        return '라이센스 구매 규정'
      } else if(termsKey === 'productSell') {
        return '지정가 판매'
      } else if(termsKey === 'contest') {
        return '공모전 등록 규정'
      } else if(termsKey === 'contestItem') {
        return '공모전 응모 규정'
      } else if(termsKey === 'contestWin') {
        return '수상작 선정 규정'
      } else if(termsKey === 'curator') {
        return '큐레이터'
      } else if(termsKey === 'curatorForm') {
        return '큐레이터 신청 규정'
      } else if(termsKey === 'curation') {
        return '큐레이션 신청 안내'
      } else if(termsKey === 'lawsuit') {
        return '의뢰안내문'
      } else if(termsKey === 'lawsuitRequest') {
        return '의뢰위임장'
      } else if(termsKey === 'mingle') {
        return '밍글'
      } else if(termsKey === 'charge') {
        return '충전 안내'
      } else if(termsKey === 'withdraw') {
        return '출금 안내'
      } else if(termsKey === 'detection') {
        return '검출 내역 안내문'
      } else if(termsKey === 'point') {
        return '포인트 사용 규정'
      } else if(termsKey === 'fees') {
        return '수수료 규정'
      }
    },

  },
  watch: {},
}
</script>

<style lang="scss">
</style>
